module.exports = __webpack_public_path__ + "img/loader.7d42c463.jpeg";